<!--
* UIID: UI-DLB-MBL-140
* UI Name: Scanner Version History
* Modify Date: 2020/07/23
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    :options="options"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="popup-history"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text" primary-title>{{
        $t('lbl.mapBuilder.tableVersionHistory.scanner')
      }}</v-card-title>
      <!-- [E]  Popup title-->
    </template>
    <template v-slot:button-close>
      <!-- <v-icon small class="mr-2" @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-card class="analyzed-dialog matched-map-list-dialog">
      <v-card-text class="popup-title pb-0">
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0">
            <span class="title-file-name--text">{{ this.versionList.SCANNER_NAME }}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [S]  Popup body-->
      <!-- // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu -->
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-card-text class="content-version-section pt-0">
        <v-row class="content-covering-m pt-0">
          <v-col cols="12" class="pa-0">
            <v-row class="version-history-table ma-0">
              <v-col cols="12" class="pa-0">
                <v-data-table
                  :hide-default-footer="true"
                  :items="scannerList"
                  :fixed-header="true"
                  class="analyzed-layout-table"
                  disable-pagination
                  disable-sort
                  :height="customHeight"
                >
                  <template v-slot:body="{ items }">
                    <thead>
                      <tr>
                        <th class="text-center text-version" style="width:51px">
                          {{ $t('tbl.mapBuilder.tableVersionHistory.ver') }}
                        </th>
                        <th class="text-center text-version" style="width:87px">
                          {{ $t('tbl.mapBuilder.tableVersionHistory.checkOut') }}
                        </th>
                        <th class="text-center text-version" style="width:133px">
                          {{ $t('tbl.mapBuilder.tableVersionHistory.date') }}
                        </th>
                        <th class="text-center text-version">
                          {{ $t('tbl.mapBuilder.tableVersionHistory.user') }}
                        </th>
                        <th class="text-center text-version">
                          {{ $t('tbl.mapBuilder.tableVersionHistory.changeHistory') }}
                        </th>
                        <th v-if="isDlb === true" class="text-center text-version">
                          {{ $t('tbl.mapBuilder.tableVersionHistory.executeFile') }}
                        </th>
                        <th class="text-center text-version" style="width:60px">
                          {{ $t('tbl.mapBuilder.tableVersionHistory.delete') }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in items" :key="item.id">
                        <td class="text-center text-bold">{{ item.SCAN_VER }}</td>
                        <td class="text-left" style="width:87px">
                          <a @click="openCheckOut(item)">{{
                            $t('tbl.mapManager.versionHistory.checkOut')
                          }}</a>
                        </td>
                        <td class="text-left">{{ item.CRE_DT }}</td>
                        <td class="text-left text-bold">{{ item.CRE_USR }}</td>
                        <td class="text-left">{{ item.CHKIN_COMT }}</td>
                        <td v-if="isDlb === true" class="text-left" style="width:87px">
                          <a @click="downloadFiOb(item)">{{
                            $t('tbl.mapBuilder.tableVersionHistory.download')
                          }}</a>
                        </td>
                        <td class="text-center">
                          <v-btn small text icon @click="deleteItem(item)">
                            <icon-svg iconName="delete" />
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">{{ $t('btn.common.reset') }}</v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup body-->

      <v-divider class="ml-0 mr-0 mt-2 divder-popup" inset></v-divider>
      <v-row class="ml-0 mr-0">
        <v-col class="button-col action-col" lg="12">
          <div class="btn-form-control text-right mr-4">
            <v-btn class="btn btn-delete" @click="removeDialog">{{ $t('btn.common.close') }}</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <dialogWindow
      ref="warningDialog"
      size="max"
      :detail="$t('msg.mapBuilder.versionHistory.warningCheckIn')"
      color="warning"
    ></dialogWindow>
    <dialogWindow
      ref="warningDownloadDialog"
      size="max"
      :detail="$t('msg.mapBuilder.versionHistory.warningDownload')"
      color="warning"
    ></dialogWindow>
    <dialogWindow
      ref="checkOutDialog"
      size="max"
      :detail="$t('msg.mapBuilder.versionHistory.okConfirm', ['scanner'])"
      color="confirmation"
      show-cancel="true"
      @select-close="onClickCancel"
      @select-ok="onClickOkay"
    ></dialogWindow>
    <dialogWindow
      ref="deleteDialog"
      size="max"
      :detail="$t('msg.common.deleteConfirm')"
      color="warning"
      show-cancel="true"
      @select-ok="onClickDelete"
    ></dialogWindow>
    <dialogWindow
      ref="successDialog"
      size="max"
      :detail="$t('msg.common.saveSuccess', ['File'])"
      color="success"
      @select-ok="onClickSave"
    ></dialogWindow>
    <dialogWindow
      ref="downloadFail"
      size="max"
      :detail="$t('msg.common.warning.notFindTargetFile')"
      color="warning"
    ></dialogWindow>
    <dialogWindow
      ref="warningCheckedOutDialog"
      size="max"
      :detail="$t('msg.common.warning.detailWarningIsCheckedOut', ['scanner', updateUserId])"
      color="validation"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
/* globals Store */
import { mapState } from 'vuex';

import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
// import controlData from '../Data/asset-creation/data_control.json';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { DownloadFile } from '@/vue-dlb/models/DownloadFile';
import cfg from '@/vue-caas/config/config.js';
// 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
// 2021.12.06 SPKA-304 svg icon
import IconSvg from '@/vue-caas/components/IconBase.vue';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';

export default {
  components: {
    DialogDrag,
    dialogWindow,
    SystemProgress,
    IconSvg,
  },
  /* 2020/10/29 203737 Change prop definitions
    props: ['id', 'title', 'options', 'eventCb', 'selectFile', 'closeDialog', 'dragStart', 'dragEnd', 'fileSelected', 'dialogCheckIn', 'versionList','reFreshList'],*/
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    versionList: Object,
    reFreshList: Function,
  },
  name: 'scanner-version-history',
  data: () => ({
    fileId: null,
    scannerName: '',
    warningDialog: false,
    checkOutDialog: false,
    warningDownloadDialog: false,
    /* 2020/11/11 203737 Remove unused source
      selectedDelete: null,*/
    lockedFlag: false,
    successDialog: false,
    downloadDialog: false,
    downloadFail: false,
    // map_table_header : controlData[0].flatFile_version_table_header,
    // map_table_data : controlData[0].flatFile_version_table_data,
    versionHistoryItems: {
      header: ['MAP_PRCS_NO'],
      data: [
        {
          FFL_PRCS_NO: '',
        },
      ],
    },
    currentVerItems: {
      header: ['MAP_KIND', 'MAP_PRCS_NO', 'MAP_HST_NO', 'FILE_ID', 'CODE_CTG_ID'],
      data: [
        {
          MAP_KIND: '',
          MAP_PRCS_NO: '',
          MAP_HST_NO: '',
          FILE_ID: '',
          CODE_CTG_ID: '',
        },
      ],
    },
    lockItems: {
      header: ['MAP_KIND', 'MAP_PRCS_NO', 'LOCK_YN'],
      data: [
        {
          MAP_KIND: '',
          MAP_PRCS_NO: '',
          LOCK_YN: '',
        },
      ],
    },
    deleteItems: {
      header: ['MAP_KIND', 'MAP_PRCS_NO', 'MAP_HST_NO', 'FILE_ID'],
      data: [
        {
          MAP_KIND: '',
          MAP_PRCS_NO: '',
          MAP_HST_NO: '',
          FILE_ID: '',
        },
      ],
    },
    /* 2020/11/11 203737 Remove unused source
      viewFileItems: {
        header: ['FILE_ID'],
        data: [{
          FILE_ID: ''
        }]
      },*/
    isDlb: false,
    isLoading: true,
    isCheckedOut: false,
    updateUserId: '',
    currentSelect: {},
    customHeight: 70,
  }),
  computed: {
    ...mapState('map', {
      scannerList: 'scannerList',
    }),
    // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
    ...mapState('common', {
      fileContent: 'fileContent',
      sysloadingTitle: 'sysloadingTitle',
    }),
  },
  methods: {
    queryList() {
      // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
      this.isLoading = true;
      this.versionHistoryItems.data[0].MAP_PRCS_NO = this.versionList.MAP_PRCS_NO;
      Store.dispatch('map/queryScannerHistoryList', this.versionHistoryItems)
        .then(() => {
          console.log('--------- Finished to process ----------');
          // console.log(JSON.stringify(this.scannerList));
          this.currentSelect = this.scannerList.find((e) => e.CURVER_YN === 'Y');
          let len = this.scannerList.length;
          this.customHeight = (len > 6 ? 6 : len + 1) * 35;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    /* 2020/10/28 203737 Remove unused source
      saveVersionHistory(){
        if(this.currentVerItems.data[0].MAP_HST_NO == ''){
          let data = JSON.parse(JSON.stringify(this.scannerList));
          let filtered = data.filter(item => item.CURVER_YN === 'Y')
          this.currentVerItems.data[0].MAP_HST_NO = filtered[0].HST_NO;
        }
        this.currentVerItems.data[0].MAP_KIND = 'SCAN';
        this.currentVerItems.data[0].MAP_PRCS_NO = this.versionList.MAP_PRCS_NO;
        Store.dispatch("map/saveCurrentVer", this.currentVerItems).then(() => {
          console.log("--------- Finished to process ----------");
          this.$refs.successDialog.dialog = true;
        });
      },*/
    /* 2020/10/28 203737 Remove unused source
      selectVersion(item){
        this.currentVerItems.data[0].MAP_HST_NO = item.HST_NO;
      },*/
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    /* 2020/10/28 203737 Remove unused source
      selectFlatFile (item){
        this.removeDialog({});
        this.selectFile(item);
      },*/
    onClickSave() {
      this.reFreshList();
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    /* 2020/10/28 203737 Remove unused source
      findIndexItem(item, arr, col) {
        let prop = (typeof col == 'undefined') ? 'id' : col;
        let index = arr.findIndex((row) => {
          return row[prop] === item[prop]
        })
        return (index > -1) ? index : null
      },
      openCheckIn () {
        if(this.versionList.MAP_SCAN_CHKIN_YN === 'N' && this.lockedFlag === false){
          this.$refs.warningDialog.dialog = true;
          return;
        }
        this.dialogCheckIn();
      },*/
    openCheckOut(item) {
      this.fileId = item;
      this.$refs.checkOutDialog.dialog = true;
    },
    downloadFiOb(item) {
      let downloadfile = new DownloadFile();
      if (item.TARGET_FILE_ID === '' || item.TARGET_FILE_ID === null) {
        this.$refs.downloadFail.dialog = true;
      } else {
        downloadfile.data[0].FILE_ID = item.TARGET_FILE_ID;
        downloadfile.data[0].SAVE_NAME = item.TARGET_FILE_NAME;
        Store.dispatch('common/DownloadFileFromServer', downloadfile).then(() => {
          console.log('--------- Finished to process ----------');
        });
      }
    },
    downloadFife() {
      let downloadfile = new DownloadFile();
      downloadfile.data[0].FILE_ID = this.fileId.FILE_ID;
      downloadfile.data[0].SAVE_NAME = this.versionList.SCANNER_NAME;

      Store.dispatch('common/DownloadFileFromServer', downloadfile).then(() => {
        console.log('--------- Finished to process ----------');
      });
    },
    onClickOkay() {
      if (this.fileId.FILE_ID != null) {
        if (this.isCheckedOut) {
          this.$refs.warningCheckedOutDialog.dialog = true;
          return;
        }
        this.lockItems.data[0].MAP_KIND = 'SCAN';
        this.lockItems.data[0].MAP_PRCS_NO = this.versionList.MAP_PRCS_NO;
        this.lockItems.data[0].LOCK_YN = 'Y';
        Store.dispatch('map/updateLock', this.lockItems).then(() => {
          console.log('--------- Finished to process CHECKOUT ----------');
          this.lockedFlag = true;
          this.reFreshList();
          if (this.options.item.action == 'scannerbuilder') {
            this.$router.push({
              query: {
                ...this.$route.query,
                mapId: this.versionList.MAP_PRCS_NO,
                ver: this.fileId.SCAN_VER,
                flag: 'Y',
                tab: 'Scanner',
              },
            });
            this.$emit('closeScannerListDialog');
            // this.downloadFife();
          } else {
            // this.downloadFife();
          }
        });
      } else {
        this.$refs.warningDownloadDialog.dialog = true;
      }
    },
    onClickCancel() {
      this.$emit('closeScannerListDialog');
    },
    deleteItem(item) {
      this.seletedDelete = item;
      this.$refs.deleteDialog.dialog = true;
    },
    onClickDelete() {
      let item = this.seletedDelete;
      this.deleteItems.data[0].MAP_KIND = 'SCAN';
      this.deleteItems.data[0].MAP_PRCS_NO = this.versionList.MAP_PRCS_NO;
      this.deleteItems.data[0].MAP_HST_NO = item.HST_NO;
      this.deleteItems.data[0].FILE_ID = item.FILE_ID;
      Store.dispatch('map/deleteSelectedHistory', this.deleteItems).then(() => {
        this.queryList();
        console.log('--------- Finished to process ----------');
      });
    },
  },

  created() {
    this.isDlb = cfg.isDlb;
    this.scannerName = this.versionList.SCANNER_NAME;
    this.queryList();
    this.isCheckedOut = this.options.item.data.isCheckedOut;
    this.updateUserId = this.options.item.data.MAP_UPD_USR;
  },
};
</script>

<style></style>
